export const COMPONENT_NAME = "wallet-fiat-new";
